import { createAction, props } from '@ngrx/store';
import { ILogbook } from './logbooks.reducer';

export const addLogbook = createAction(
  '[Logbooks] Add Logbook',
  props<{ logbook: ILogbook }>()
);
